<template>
  <div class="preview position-relative">
    <div class="m-auto h-100 w-100">
      <div class="d-flex flex-column align-items-center">
        <div class="fw-bold"><p>{{ getTitleText }}</p></div>

        <div class="d-flex" style="gap: 8px;">
          <div class="position-relative cursor-pointer" style="width: 100px; height: 40px;" @click="onClickReturnBtn()">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="40" viewBox="0 0 100 40" fill="none">
            <path d="M17.668 1H97C98.1046 1 99 1.89543 99 3V37C99 38.1046 98.1046 39 97 39H17.668C17.0655 39 16.495 38.7284 16.1152 38.2607L2.31152 21.2607C1.71513 20.5262 1.71513 19.4738 2.31152 18.7393L16.1152 1.73926C16.495 1.27158 17.0655 1 17.668 1Z" fill="white" stroke="#8C9BC6" stroke-width="2"/>
            </svg>
            <div class="position-absolute fw-bold" style="font-size: 16px; color: #8C9BC6; top: 8px; left: 32px;">もどる</div>
          </div>

          <div class="preview-area border border-1 border-dark" :style="getCanvasSize">
            <div class="w-100 h-100" style="position: relative">
              <!-- ドラッグ出来ないようにdivで表示 -->
              <div v-if="this.$store.state.eventCreateData.designData"
                ref="designImage"
                class="design"
                :style="getDesignImageStyle"
              />
              <div v-if="this.$store.state.eventCreateData.cutlineData"
                ref="cutlineImage"
                class="cutLine"
                :style="getCutlineImageStyle"
              />
              <div v-if="this.$store.state.eventCreateData.nonEditableData"
                ref="nonEditableImage"
                class="nonEditable"
                :style="getNonEditableImageStyle"
              />
              <!-- <canvas ref="canvas" class="w-100 h-100 cutLine"></canvas> -->
            </div>
            <!-- <img class="w-100 h-100" style="object-fit: scale-down;" v-if="(!isUploadDesign && !isUploadCutline)" :src="getUploadImage"> -->
          </div>

          <div class="" style="width: 100px;">
          </div>

        </div>


      </div>
      <div class="d-flex flex-column mt-4">
        <div class="caution-title">注意事項</div>
        <div class="caution-text text-start py-2 px-3">
          <p class="m-0">・プレビュー上でのカットラインは半透明で表現しています。</p>
          <p class="m-0">・プレビューによるデザインとカットラインを元に制作いたします。</p>
          <p class="m-0">・カットラインが正しく作成されていないと製造ができませんのでご注意ください。</p>
          <p class="m-0">・カットラインとデザインが交わっている箇所はプリントが剥がれやすくなります。</p>
          <p class="m-0">・アタッチメントのつけ忘れ、5mm以下の小さなパーツは再現性の低下や破損に繋がります。また保証対象外となりますのでご注意ください。</p>
        </div>
      </div>
    </div>

    <!-- チュートリアル用1 -->
    <div class="tutorial-modal p-4" style="height:242px; top:60px;" :style="getTop(120)"
    v-if="this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 1">
      <p class="text-start fw-bold">デザイン入稿（PNG）</p>
      <p class="text-start">作成されたPNGデータをアップロードします</p>
      <p class="text-start m-0">アップロードするとキャンバスにプレビュー表示されます。</p>
      <p class="text-start">プレビューでズレが発生する場合サイズが間違っている可能性がありますのでデータを確認ください。</p>
      <button class="acry-btn position-absolute" style="width:105px; height:40px; border-radius: 40px; rihgt:10px; right: 18px;"
      @click="tutorialNextStep()">
        OK
      </button>
      <!-- 吹き出し -->
      <div class="position-absolute" style="right:-15px; top:40px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32" fill="none">
        <path d="M33.1075 15.0974C33.8669 15.4596 33.8669 16.5404 33.1075 16.9026L1.93048 31.7722C1.26683 32.0888 0.499998 31.6049 0.499999 30.8696L0.5 1.13037C0.5 0.395104 1.26683 -0.0887492 1.93048 0.227774L33.1075 15.0974Z" fill="white"/>
        </svg>
      </div>
    </div>

    <!-- チュートリアル用2 -->
    <div class="tutorial-modal p-4" style="height:242px;" :style="getTop(210)"
    v-if="this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 2">
      <p class="text-start fw-bold">カットライン入稿（SVG）</p>
      <p class="text-start">作成されたSVGデータをアップロードします</p>
      <p class="text-start m-0">アップロードするとキャンバスにプレビュー表示されます。</p>
      <p class="text-start">パス情報をカットラインとして作成されますのでPNGデータと位置が合っているかご確認ください。</p>
      <button class="acry-btn position-absolute" style="width:105px; height:40px; border-radius: 40px; rihgt:10px; right: 18px;"
      @click="tutorialNextStep()">
        OK
      </button>
      <!-- 吹き出し -->
      <div class="position-absolute" style="right:-15px; top:40px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32" fill="none">
        <path d="M33.1075 15.0974C33.8669 15.4596 33.8669 16.5404 33.1075 16.9026L1.93048 31.7722C1.26683 32.0888 0.499998 31.6049 0.499999 30.8696L0.5 1.13037C0.5 0.395104 1.26683 -0.0887492 1.93048 0.227774L33.1075 15.0974Z" fill="white"/>
        </svg>
      </div>
    </div>


    <!-- チュートリアル用3 -->
    <div class="nonEditable-modal d-flex flex-column m-auto" style="padding: 24px 48px;"
    v-if="this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 3">
      <div style="font-size: 28px; color: #595959; font-weight: 700; padding-bottom: 10px;">
        編集禁止領域について
      </div>

      <div class="d-flex flex-column scrollbar" style="widht: 673px; padding-top: 10px; gap: 24px; overflow-y: scroll;">
        <p class="text-start mt-1">アクリルデザインの一部に編集禁止領域を設ける事で、デザインを守る事が可能になります。</p>

        <div>
          <div style="border-radius: 20px; background: #B1C0DB; width: 190px; height: 30px; color: #FFFFFF; font-weight: 700; padding-top: 2px;">
            <p>編集禁止領域とは？</p>
          </div>
          <p class="text-start m-0">アクリルデザインの特定の場所を指定することで、チケット使用者が編集する事が出来なくなります。</p>
          <p class="text-start m-0">（下図の赤色の箇所が編集出来ない領域として設定する事ができます。）</p>
        </div>

        <img style="height: 263px; object-fit: contain;" src="@/assets/acrypro/coupon/nonEditable_info1.png" />
        <img style="height: 145px; object-fit: contain;" src="@/assets/acrypro/coupon/nonEditable_info2.png" />
      </div>

      <button class="border-0 bg-transparent position-absolute" style="top: 10px; right: 10px;" @click="hideModel()">
        <img src="@/assets/acrypro/close.svg">
      </button>

    </div>
  </div>

</template>

<script>
import {
  ProductId,
  GetCanvasSize,
  RightViewState,
} from "@/js/Const.js";


export default {
  name: "CenterViewEventDesignUpload_Ap",
  props: {},
  data: function () {
    return {

    };
  },
  computed: {
    getProductId(){
      switch(this.$store.state.eventCreateData.selectSize){
        case "S": return ProductId.S_SVG;
        case "M": return ProductId.M_SVG;
        case "L": return ProductId.L_SVG;
        default: return 0;
      }
    },
    getCanvasSize(){
      let canvasSize = GetCanvasSize(this.getProductId);
      return {
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
        };
    },
    getDesignImageStyle() {
      let canvasSize = GetCanvasSize(this.getProductId);
      return {
        "background-image": 'url("' + this.$store.state.eventCreateData.designData.fileURL + '"',
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
      };
    },
    getCutlineImageStyle() {
      let canvasSize = GetCanvasSize(this.getProductId);
      return {
        "background-image": this.$store.state.eventCreateData.frameCutlineImageURL
          ? 'url("' + this.$store.state.eventCreateData.frameCutlineImageURL + '"'
          : 'url("' + this.$store.state.eventCreateData.cutlineImageURL + '"',
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
      };
    },
    getNonEditableImageStyle() {
      let canvasSize = GetCanvasSize(this.getProductId);
      return {
        "background-image": 'url("' + this.$store.state.eventCreateData.nonEditableData.fileURL + '"',
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
      };
    },
    getTitleText(){
      switch(this.$store.state.eventCreateData.selectSize){
        case "S": return "Sサイズ";
        case "M": return "Mサイズ";
        case "L": return "Lサイズ";
        default: return "";
      }
    },
  },
  async created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("hideRightMenu");

    this.$store.commit("showLoading");

    await this.$store.state.acrylicTicketCouponManager.update().catch(() => {
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "エラーが発生しました");
    });

    this.$store.commit("hideLoading");
  },
  components: {
    
  },
  methods: {
    onClickReturnBtn(){
      this.$store.commit("setRightViewState", RightViewState.Cart);
      this.$store.commit("setPreviousCenterViewState");
    },
    tutorialNextStep(){
      if( this.$store.state.tutorial.isFirst ){
        // 初回は強制で全て表示
        if(this.$store.state.tutorial.previewStep == 2){
          this.$store.commit("hidePreviewTutorial");
          this.$store.commit("setIsFirstTutorial", false);
        }else{
          this.$store.commit("previewTutorialNextStep");
        }
      }else{
        // 2回目以降は一部分のみ表示
          this.$store.commit("hidePreviewTutorial");
      }
    },
    hideModel(){
      this.$store.commit("hidePreviewTutorial");
    },
    getTop(top) {
      return {
        'top': `${top - this.$store.state.tutorial.previewTutorialScroll}px`,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.preview{
  // max-width: 805px;
  width: 100%;
  padding: 16px 32px;
}

.control-area{
  margin-left: 16px;
  width: 243px;
}

.caution-title {
  font-weight: bold;
  color: $text-white-color;
  background-color: $status-error-color;
  border: solid 1px $status-error-color;
  border-radius: 5px 5px 0px 0px;
}

.caution-text {
  font-size: 12px;
  font-weight: bold;
  color: $status-error-color;
  background-color: $background-white-color;
  border: solid 1px $status-error-color;
  border-radius: 0px 0px 5px 5px;
}

.design {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.cutLine {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  opacity: 0.3;
}

.nonEditable {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.5;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.tutorial-modal{
  width: 850px;
  position: fixed;
  right: 310px;
  z-index: 3;
  background: white;
  border-radius: 4px;
}

.nonEditable-modal{
  position: fixed;
  height: 80%;
  max-height: 742px;
  width: 750px;
  z-index: 3;
  background: white;
  border-radius: 4px;

  top: 10%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);

  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}
.scrollbar::-webkit-scrollbar {
    display: none;
}

</style>